import { getApi } from '../../../utils/api'

export function getRequestStatuses() {
  return getApi({ endpoint: '/api/request-statuses/' })
}
